// Files placed in frontend/public are served from the site root.
export const HERO_VIDEO_PATH = "/media/Home%20-%20TESSA.mp4";
